import './DealerDisplay.css';
import React from 'react';
import PropTypes from 'prop-types';
import EmptyStar from '../../assets/icons/star-empty-yellow.svg';
import FilledStar from '../../assets/icons/star-blue-filled.svg';
import {updateSelectedDealer, updateToggleDealerConnectDialog, updateToggleDealerSubmissionDialog} from '../../redux/app-state-slice';
import {timeFormat} from '../../utils/functions/Functions';
import Button from '../Button/Button';

export function setStarRating(rating) {
  const ratingAsDouble = parseFloat(rating);
  if (ratingAsDouble) {
    return Math.round(ratingAsDouble);
  }
  return 0;
}

function createStarDisplay(rating) {
  const starDisplay = [];
  let index;
  for (index = 1; index <= 5; index++) {
    starDisplay.push(
      <img
        className={
          index <= rating ? 'prequal--web--star-tip prequal--web--align-right' : 'prequal--web--star-tip-empty prequal--web--align-right'
        }
        src={index <= rating ? FilledStar : EmptyStar}
        alt='star tip'
        key={`star${index}`}
      />
    );
  }
  return starDisplay;
}

function DealerDisplay({sequence, dealerDetails, hasSelectButton = false, dispatch, customerData}) {
  const isMobile = window.innerWidth < 1024;
  const rating = dealerDetails.dealerQualityRating;
  const address1 = dealerDetails.dealerAddress.streetAddress;
  const address2 = dealerDetails.dealerAddress.apartment;
  const dealerCity = dealerDetails.dealerAddress.city;
  const dealerState = dealerDetails.dealerAddress.state;
  const dealerPostalCode = dealerDetails.dealerAddress.postalCode;
  const distance = dealerDetails.dealerDistance;
  const distanceKm = dealerDetails.dealerDistanceKm;
  const closingTime = dealerDetails.dealerClosingTime;
  const {dealerPhone} = dealerDetails;
  const dealerPhoneUrl = `tel:${dealerPhone}`;
  const dealerUrl = dealerDetails.dealerWebsiteUrl;

  const selectDealer = () => {
    const selectedDealer = {
      source: 'FordDirect',
      code: dealerDetails.dealerCode,
      vendorName: dealerDetails.dealerName,
      vendorBrand: 'Ford'
    };
    dispatch(updateSelectedDealer(selectedDealer));
    dispatch(updateToggleDealerConnectDialog(false));
    dispatch(updateToggleDealerSubmissionDialog(true));
  };

  return (
    <div className='prequal--web--dealer-outer-container'>
      <div className='prequal--web--dealer-container' key={`dealer-display-${sequence}`}>
        <div className='prequal--web--dealer-details'>
          <div data-testid='dealer-display-test'>
            <span className='prequal--web--dealer-details-name'>{sequence}.</span>{' '}
            <a className='prequal--web--dealer-details-name' href={dealerUrl} target='_blank' rel='noreferrer'>
              {dealerDetails.dealerName}
            </a>
          </div>
          <div className='prequal--web--p--t-1'>
            {rating !== '' && (
              <div className='prequal--web-flex prequal--web--p--b-1'>
                <span className='prequal--web--dealer-rating'>{rating}</span>
                {createStarDisplay(setStarRating(rating)).map((star) => star)}
              </div>
            )}
            <div className='prequal--web--dealer-info'>
              {isMobile ? (
                <>
                  <div className='prequal--web--dealer-address1'>{address1} </div>
                  <div className='prequal--web--dealer-address2'>{address2} </div>
                  <div className='prequal--web--dealer-address2'>
                    {dealerCity}, {dealerState} {dealerPostalCode}
                  </div>
                </>
              ) : (
                <div className='prequal--web--dealer-address1'>
                  {address1}, {address2 ? `${address2}, ` : ''}
                  {dealerCity}, {dealerState} {dealerPostalCode}
                </div>
              )}
              <div className='prequal--web--dealer-distance'>
                {customerData.countryCode.value === 'USA' ? `${distance} miles ` : `${distanceKm} kilometers `}
                {closingTime && closingTime !== '' && (
                  <>
                    | Sales until&nbsp;
                    {timeFormat(closingTime)}
                  </>
                )}
              </div>
              <div className='prequal--web--dealer-phone'>
                <a href={dealerPhoneUrl}>{dealerPhone}</a>
              </div>
            </div>
          </div>
        </div>
        {hasSelectButton && (
          <div id='select-dealer-button' className='prequal--web--select-dealer-button-fomo' data-testid='select-dealer-button'>
            <Button dataTestId='select-dealer-fomo' label='Select Dealer' onClick={() => selectDealer()} />
          </div>
        )}
      </div>
    </div>
  );
}

DealerDisplay.propTypes = {
  sequence: PropTypes.number,
  dealerDetails: PropTypes.object,
  hasSelectButton: PropTypes.bool,
  dispatch: PropTypes.func
};

DealerDisplay.defaultProps = {
  sequence: 0,
  dealerDetails: null,
  hasSelectButton: false,
  dispatch: null
};
export default DealerDisplay;
